import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Country, State,} from '../modules/clients/models/client.model';
import { environment } from 'src/environments/environment';
import { TimeZone } from '../modules/usermanagement/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class MiscService {
  private apiUrl = `${environment.apiURL}`;

  constructor(private http: HttpClient) {}

  getCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(`${this.apiUrl}/misc/countries`);
  }

  getStatesByCountryId(countryGuid: string): Observable<State[]> {
    return this.http.get<State[]>(`${this.apiUrl}/misc/states/${countryGuid}`);
  }

  getTimeZones(): Observable<TimeZone[]> {
    return this.http.get<TimeZone[]>(`${this.apiUrl}/misc/timeZone`);
  }
}